import axios from 'axios';
import { Sponsor } from '@repo/types';
import API from '../endpoints';
import { useQuery } from '@tanstack/react-query';
import { getAccessToken } from '../utils/getAccessToken';
import { useGlobalContext } from '@slc/tools/GlobalContext';

// 30 minutes frontend cache for main sponsor query
const CACHE_TIME = 30 * 60 * 1000;

export const useMainSponsorQuery = () => {
  const { apiUrl } = useGlobalContext();
  const accessToken = getAccessToken();

  return useQuery({
    queryKey: ['main-sponsor', apiUrl],
    queryFn: () => fetchMainSponsor(apiUrl),
    staleTime: !accessToken ? CACHE_TIME : undefined,
    enabled: !!apiUrl,
  });
};

const fetchMainSponsor = async (apiUrl: string): Promise<Sponsor> => {
  const { data } = await axios.get<Sponsor>(`${apiUrl}${API.endpoints.mainSponsor}`);
  return data;
};
